module.exports = __webpack_public_path__ + "symantec_70x70.d1b08926ae67f4a37a238117c3b144db.png";